"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareWebsocketData = exports.prepareData = void 0;
const stream_1 = require("./stream");
/**
 * Validates input and converts to Uint8Array
 *
 * @param data any string, ArrayBuffer or Uint8Array
 */
async function prepareData(data) {
    if (typeof data === 'string')
        return new Blob([data], { type: 'text/plain' });
    if (data instanceof Uint8Array || data instanceof ArrayBuffer) {
        return new Blob([data], { type: 'application/octet-stream' });
    }
    if (data instanceof Blob) {
        return data;
    }
    // Currently it is not possible to stream requests from browsers
    // there are already first experiments on this field (Chromium)
    // but till it is fully implemented across browsers-land we have to
    // buffer the data before sending the requests.
    if ((0, stream_1.isNodeReadable)(data)) {
        return new Promise(resolve => {
            const buffers = [];
            data.on('data', d => {
                buffers.push(d);
            });
            data.on('end', () => {
                resolve(new Blob(buffers, { type: 'application/octet-stream' }));
            });
        });
    }
    if ((0, stream_1.isReadableStream)(data)) {
        return new Promise(async (resolve) => {
            const reader = data.getReader();
            const buffers = [];
            let done, value;
            do {
                ;
                ({ done, value } = await reader.read());
                if (!done) {
                    buffers.push(value);
                }
            } while (!done);
            resolve(new Blob(buffers, { type: 'application/octet-stream' }));
        });
    }
    throw new TypeError('unknown data type');
}
exports.prepareData = prepareData;
async function prepareWebsocketData(data) {
    if (typeof data === 'string')
        return new TextEncoder().encode(data);
    if (data instanceof ArrayBuffer)
        return new Uint8Array(data);
    if (data instanceof Blob)
        return new Uint8Array(await new Response(data).arrayBuffer());
    throw new TypeError('unknown websocket data type');
}
exports.prepareWebsocketData = prepareWebsocketData;
